exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".word-break {\n  word-wrap: break-word;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/developer/Downloads/SleepRestoreBackend/sleep-restore-boot/src/main/ngapp/src/app/questionnaire-report/questionnaire-report.component.css
// module id = ../../../../../src/app/questionnaire-report/questionnaire-report.component.css
// module chunks = main